import { render, staticRenderFns } from "./sub-items.vue?vue&type=template&id=359c3bfb&scoped=true&"
import script from "./sub-items.vue?vue&type=script&lang=js&"
export * from "./sub-items.vue?vue&type=script&lang=js&"
import style0 from "./sub-items.vue?vue&type=style&index=0&id=359c3bfb&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c3bfb",
  null
  
)

export default component.exports